import {
  CurecallTextarea,
  CurecallButton,
  ECurecallButtonAppearance,
  ECurecallSize,
} from '@honestica/curecall-ui'
import { useState, FormEvent, useEffect, useRef } from 'react'
import { useTranslation } from 'react-i18next'

export type TMedicalTeamCommentInputProps = {
  onPostComment: (comment: string) => void
  onCancel?: VoidFunction
  defaultValue?: string
}

const MedicalTeamCommentInput = ({
  onPostComment,
  onCancel,
  defaultValue,
}: TMedicalTeamCommentInputProps) => {
  const [text, setText] = useState<string>('')
  const textAreaRef = useRef<HTMLTextAreaElement | null>(null)

  const { t } = useTranslation()

  const handlePostComment = (e: FormEvent<HTMLFormElement>) => {
    e.preventDefault()
    onPostComment(text)
    setText('')
  }

  const handleCancel = () => {
    onCancel?.()
    setText('')
  }

  useEffect(() => {
    if (defaultValue) {
      setTimeout(() => {
        textAreaRef.current?.focus()
      }, 600)
      setText(defaultValue)
    }
  }, [defaultValue])

  return (
    <div className="c-relative c-flex-grow c-mb-3">
      <form className="c-flex c-flex-col c-gap-3" onSubmit={handlePostComment}>
        <CurecallTextarea
          ref={textAreaRef}
          name="comment input"
          rows={2}
          textareaClassName="c-w-full c-text-xs"
          placeholder={t('components.medical-team-comments.input-placeholder')}
          value={text}
          onChange={(e) => setText(e.target.value)}
          label={
            defaultValue
              ? t('components.medical-team-comments.input-label-edit')
              : t('components.medical-team-comments.input-label-add')
          }
          isRequired={true}
          required={true}
        />
        <div className="c-flex c-gap-4 c-justify-end">
          <CurecallButton
            onClick={handleCancel}
            isDisabled={!text.length && !defaultValue}
            appearance={ECurecallButtonAppearance.CANCEL}
            size={ECurecallSize.SMALL}
          >
            {t('components.medical-team-comments.input-cancel')}
          </CurecallButton>
          <CurecallButton
            type="submit"
            appearance={ECurecallButtonAppearance.SECONDARY}
            size={ECurecallSize.SMALL}
          >
            {t('components.medical-team-comments.input-confirm')}
          </CurecallButton>
        </div>
      </form>
    </div>
  )
}

export default MedicalTeamCommentInput
